import { Message } from '@microsoft/microsoft-graph-types'

export const FILE_REFERENCE_NUMBER_PROP: string = 'String {8ad96481-9a7a-4164-97c5-33c1f0797699} Name hammockFiles'
export const FILE_REFERENCE_REGEX: RegExp = /\[[\w\d-_]+?]/g
export const FILE_BRACKET_REGEX: RegExp = /[\[\]]/g

// We cannot use lookforward and lookbehind regexes, therefore we split the extraction regex in 2 operations.
export const extractReferenceNumbers = (subject?: string): string[] =>
    (subject || '').match(FILE_REFERENCE_REGEX)?.map(match => match.replace(FILE_BRACKET_REGEX, ''))

export const extractReferenceNumbersFromMessage = (message?: Message) =>
    extractReferenceNumbers(
        message?.singleValueExtendedProperties?.find(prop => prop.id === FILE_REFERENCE_NUMBER_PROP)?.value,
    )
